import { AiFillIdcard } from 'react-icons/ai';
import { BiSolidBarChartAlt2, BiSolidChat, BiSolidMessageAltError } from 'react-icons/bi';
import { BsClipboard2CheckFill, BsPersonFillExclamation } from 'react-icons/bs';
import { FaGraduationCap, FaUmbrellaBeach, FaShoppingCart } from 'react-icons/fa';

import { FaTriangleExclamation } from 'react-icons/fa6';
import { HiClipboardDocumentList, HiMiniDocumentMagnifyingGlass } from 'react-icons/hi2';
import { IoBagHandleSharp, IoLibrary, IoShieldCheckmarkSharp } from 'react-icons/io5';
import { MdTimer } from 'react-icons/md';
import { PiListChecksFill, PiMedalFill } from 'react-icons/pi';
import { RiStackFill } from 'react-icons/ri';

export const chantiersItems = [
    {
        title: 'Approvisionnement',
        icon: <IoBagHandleSharp />,
        link: '/mes-chantiers/approvisionnement'
    },
    {
        title: 'Levée de réserve et quitus',
        icon: <BsClipboard2CheckFill />,
        link: ''
    },
    {
        title: 'Essai / AQC',
        icon: <PiListChecksFill />,
        link: '/mes-chantiers/testsheets'
    },
    {
        title: 'Mes résultats de chantier',
        icon: <BiSolidBarChartAlt2 />,
        link: '/mes-chantiers/my-worksite-results'
    },
    {
        title: "Remontée d'évènement",
        icon: <BiSolidMessageAltError />,
        link: '/mes-chantiers/event-feedback'
    },
    {
        title: 'Bibliothèque chantier',
        icon: <IoLibrary />,
        link: '/mes-chantiers/bibliotheque'
    }
];

export const richessesHumainesItems = [
    {
        title: 'Pointage',
        icon: <MdTimer />,
        link: '/richesses-humaines/pointage'
    },
    {
        title: "Demandes d'absence",
        icon: <FaUmbrellaBeach />,
        link: '/richesses-humaines/conges'
    },
    {
        title: 'Bibliothèque RH',
        icon: <RiStackFill />,
        link: '/richesses-humaines/bibliotheque'
    },
    {
        title: 'Carte BTP',
        icon: <AiFillIdcard />,
        link: '/richesses-humaines/carte-btp'
    },
    {
        title: 'Remontées RH',
        icon: <BsPersonFillExclamation />,
        link: '/richesses-humaines/event-feedback'
    }
];

export const santeSecuriteItems = [
    {
        title: 'Accueil sécurité',
        icon: <IoShieldCheckmarkSharp />,
        link: '/sante-securite/home-security/menu'
    },
    {
        title: "Remontée d'évènement",
        icon: <FaTriangleExclamation />,
        link: '/sante-securite/event-feedback'
    },
    {
        title: 'Causeries',
        icon: <BiSolidChat />,
        link: '/sante-securite/causeries'
    },
    {
        title: 'Visite de sécurité',
        icon: <HiMiniDocumentMagnifyingGlass />,
        link: '/sante-securite/security-audit'
    },
    {
        title: 'PPSPS',
        icon: <HiClipboardDocumentList />,
        link: '/sante-securite/ppsps'
    },
    {
        title: "Règles d'or",
        icon: <PiMedalFill />,
        link: '/sante-securite/golden-rules'
    },
    {
        title: "Demande d'EPI",
        icon: <FaShoppingCart />,
        link: '/sante-securite/epi'
    },
    {
        title: 'Bibliothèque sécurité',
        icon: <IoLibrary />,
        link: '/sante-securite/bibliotheque'
    },
    {
        title: 'Module de formation',
        icon: <FaGraduationCap />,
        link: '/sante-securite/formations'
    }
];
